import { Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface AddPartnerCardProps {
  onAddPartner?: () => void;
}

export const AddPartnerCard: FC<AddPartnerCardProps> = ({ onAddPartner }) => {
  return (
    <Flex
      _hover={{ borderColor: 'whiteAlpha.500' }}
      alignItems="center"
      aria-label="Add partner"
      as="button"
      border="1px dashed"
      borderColor="whiteAlpha.300"
      borderRadius="lg"
      cursor="pointer"
      direction="column"
      height="130px"
      justifyContent="center"
      minWidth="130px"
      transition="border-color 0.2s"
      type="button"
      onClick={onAddPartner}
    >
      <Text color="whiteAlpha.600" fontSize="sm">
        Add
      </Text>
    </Flex>
  );
};
